import { isAdminRole } from "@seagames/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ReportsSetup } from "../../components/reports/report-pages";

/** Central Report Engine › Setup: what every report prints in its header and footer. ADMIN reads, SUPER_ADMIN edits. */
export const Route = createFileRoute("/_app/reports/setup")({
	beforeLoad: ({ context }) => {
		if (!isAdminRole(context.session.active_role)) throw redirect({ to: "/reports" });
	},
	component: ReportsSetupPage,
});

function ReportsSetupPage() {
	const { session } = Route.useRouteContext();
	return <ReportsSetup session={session} />;
}
